import BaseInterface from '../baseInterface';
import { notificationTypes } from '../../../utils/notificationTypes';
import Queue from '../../../utils/queue';

export default class SystemUIInterface extends BaseInterface {
  constructor(...props) {
    super(...props);
    this._popupScreensQueue = new Queue(this._executeScreen.bind(this));
    this._popupScreensActive = false;
    this._captchaListeners = new Set();
  }

  handleModelChange({ partnerConfig, tournamentsInfo, gameInited, initConfig, preloadingComplete, rounds_history }) {
    this._Controller.partnerConfig = partnerConfig;

    if (gameInited && !this._controllersInited) {
      this._controllersInited = true;
      this.controllers[this.controllerTypes.ECT_SIDEBAR].init();

      if (!partnerConfig.isBugReportFormDisabled) {
        this._Controller._excludedControllerTypes.delete(this.controllerTypes.ECT_BUG_REPORT_PRELOADER_BUTTON);
        this._Controller._initController(this.controllerTypes.ECT_BUG_REPORT_PRELOADER_BUTTON);
      }

      this.controllers[this.controllerTypes.ECT_RULES].config = {
        bundle: initConfig.bundle,
        lang: initConfig.lang,
      };
      if (partnerConfig.showRulesOnStart) this.controllers[this.controllerTypes.ECT_RULES].show();
    }

    if (gameInited && tournamentsInfo) {
      this.controllers[this.controllerTypes.ECT_TOURNAMENTS].updateData(tournamentsInfo);
      this.controllers[this.controllerTypes.ECT_MODAL_TOURNAMENT_END].updateData(tournamentsInfo);
      this.controllers[this.controllerTypes.ECT_TOURNAMENTS_START_SCREEN].updateData(tournamentsInfo);
      this.controllers[this.controllerTypes.ECT_TOURNAMENTS_UPCOMING_SCREEN].updateData(tournamentsInfo);
    }

    if (preloadingComplete) {
      if (this.controllers[this.controllerTypes.ECT_BUG_REPORT_PRELOADER_BUTTON]) {
        this.controllers[this.controllerTypes.ECT_BUG_REPORT_PRELOADER_BUTTON].hide();
      }

      if (this.controllers[this.controllerTypes.ECT_INFO_PANEL] && !this.controllers[this.controllerTypes.ECT_INFO_PANEL].isMounted) {
        this.controllers[this.controllerTypes.ECT_INFO_PANEL].init();
      }

      if (!this._popupScreensActive) {
        this._popupScreensActive = true;
        this._popupScreensQueue.add(this.controllers[this.controllerTypes.ECT_TOURNAMENTS_UPCOMING_SCREEN]);
        this._popupScreensQueue.add(this.controllers[this.controllerTypes.ECT_TOURNAMENTS_START_SCREEN]);
        this._popupScreensQueue.add(this.controllers[this.controllerTypes.ECT_MODAL_TOURNAMENT_END]);
      }
    }

    this.controllers[this.controllerTypes.ECT_ROUNDS_HISTORY].updateData(rounds_history);
    if (gameInited) this.controllers[this.controllerTypes.ECT_WIN_LIMITS].updateData(partnerConfig);
  }

  handleWinLimits() {
    const lastServerResponse = window.OPWrapperService.model.data.serverResponses ?
      window.OPWrapperService.model.data.serverResponses[window.OPWrapperService.model.data.serverResponses.length - 1] : null;
    const { isWinLimitReached, winLimit } = (lastServerResponse || {});

    if (isWinLimitReached) {
      window.OPWrapperService.SystemUI.hideNotification(window.OPWrapperService.SystemUI.eNotificationTypes.ENT_WIN_LIMIT_EXCEEDED, window.OPWrapperService.SystemUI.systemNotificationTypes.WIN_LIMIT_EXCEEDED);
      window.OPWrapperService.SystemUI.showNotification(window.OPWrapperService.SystemUI.eNotificationTypes.ENT_WIN_LIMIT_EXCEEDED, {
        ...window.OPWrapperService.SystemUI.systemNotificationTypes.WIN_LIMIT_EXCEEDED,
        winLimit,
      });
    } else {
      window.OPWrapperService.SystemUI.hideNotification(window.OPWrapperService.SystemUI.eNotificationTypes.ENT_WIN_LIMIT_EXCEEDED, window.OPWrapperService.SystemUI.systemNotificationTypes.WIN_LIMIT_EXCEEDED);
    }
  }

  showNotification(type, data) {
    this.controllers[this.controllerTypes.ECT_NOTIFICATIONS].showNotification(type, data);
  }

  hideNotification(type, data) {
    this.controllers[this.controllerTypes.ECT_NOTIFICATIONS].hideNotification(type, data);
  }

  handleTournamentStart(tournamentId) {
    this.controllers[this.controllerTypes.ECT_TOURNAMENTS_UPCOMING_SCREEN].handleStart(tournamentId);
    this.controllers[this.controllerTypes.ECT_TOURNAMENTS_START_SCREEN].handleStart(tournamentId);
    this.controllers[this.controllerTypes.ECT_SIDEBAR].tryInitTournamentsButton();
  }

  handleTournamentEnd(tournamentId) {
    this.controllers[this.controllerTypes.ECT_MODAL_TOURNAMENT_END].handleEnd(tournamentId);
  }

  handleTournamentAnnouncement(tournamentId) {
    this.controllers[this.controllerTypes.ECT_TOURNAMENTS_UPCOMING_SCREEN].handleUpcoming(tournamentId);
    this.controllers[this.controllerTypes.ECT_SIDEBAR].tryInitTournamentsButton();
  }

  showTournamentResults(tournamentId) {
    this.controllers[this.controllerTypes.ECT_TOURNAMENTS].openArchiveTournament(tournamentId);
    this.toggleControllerVisibility(this.controllerTypes.ECT_TOURNAMENTS, true);
  }

  showTournaments() {
    const futureTournament = window.OPWrapperService.model.data.tournamentsInfo && window.OPWrapperService.model.data.tournamentsInfo.future.find(details => !!details.showAnnouncement);
    if (futureTournament) {
      this.controllers[this.controllerTypes.ECT_TOURNAMENTS_UPCOMING_SCREEN].showUpcomingTournament(futureTournament.uniqueId);
    } else {
      this.toggleControllerVisibility(this.controllerTypes.ECT_TOURNAMENTS, true);
    }
  }

  tryToShowLimitsOnStart(config) {
    this.controllers[this.controllerTypes.ECT_WIN_LIMITS].tryToShowLimitsOnStart(config);
  }

  tryToShowRealityCheck(config) {
    this.controllers[this.controllerTypes.ECT_REALITY_CHECK].tryToShowOnStart(config);
  }

  toggleBackgroundSoundSettings(enabled) {
    this.controllers[this.controllerTypes.ECT_GAME_SETTINGS].toggleBackgroundSound(enabled);
  }

  toggleGameSoundSettings(enabled) {
    this.controllers[this.controllerTypes.ECT_GAME_SETTINGS].toggleGameSound(enabled);
  }

  toggleWinSoundSettings(enabled) {
    this.controllers[this.controllerTypes.ECT_GAME_SETTINGS].toggleWinSound(enabled);
  }

  updateBalanceInfo(balance) {
    this.controllers[this.controllerTypes.ECT_INFO_PANEL].updateBalanceInfo(balance);
  }

  showGoogleCaptcha(type) {
    const script = document.getElementById('g-recaptcha-init-script');
    if (!script) this._Controller._addGoogleCaptcha();
    this._captchaListeners.add(type);
    document.body.classList.add('captcha-visible');

    if (typeof window.grecaptcha === 'undefined') {
      window.grecaptcha = {};
      window.grecaptcha.ready = function (cb) {
        if (Object.keys(window.grecaptcha.length === 1)) {
          // window.__grecaptcha_cfg is a global variable that stores reCAPTCHA's
          // configuration. By default, any functions listed in its 'fns' property
          // are automatically executed when reCAPTCHA loads.
          const c = '___grecaptcha_cfg';
          window[c] = window[c] || {};
          (window[c]['fns'] = window[c]['fns'] || []).push(cb);
        } else {
          cb();
        }
      }
    }

    return {
      remove: () => this.hideGoogleCaptcha(type),
      execute: (func, action = 'submit') => {
        window.grecaptcha.ready(() => window.grecaptcha.execute(this._Controller.googleCaptchaToken, { action }).then(func));
      }
    };
  }

  hideGoogleCaptcha(type) {
    this._captchaListeners.delete(type);
    if (!this._captchaListeners.size) {
      document.body.classList.remove('captcha-visible');
    }
  }

  toggleControllerVisibility(type, visibility) {
    const controller = this.controllers[type];
    if (!controller) return console.error(`Unhandled controller type: '${type}'`);

    const condition = visibility !== undefined ? visibility : controller.isHidden;

    if (condition) {
      controller.show();
    } else {
      controller.hide();
    }
  }

  _executeScreen(controller) {
    return new Promise(async resolve => {
      controller.canBeShown = true;
      await controller.execution;
      resolve();
    })
  }

  set theme(config) {
    this._Controller.theme = config;
  }

  get eNotificationTypes() {
    return this.controllers[this.controllerTypes.ECT_NOTIFICATIONS].eNotificationTypes;
  }

  get systemNotificationTypes() {
    return notificationTypes;
  }
}
